import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Table,
  Card,
  Container,
  Spinner,
  Badge,
  Pagination, Col, Row
} from "react-bootstrap";

import { getLuckyDraws } from "../../store/slices/luckydraw";
import "../../table.css";
import { useNavigate, Link } from "react-router-dom";

export default function LuckyDraws() {
  const dispatch = useDispatch();

  const {
    luckyDraws,
    loading,
    error,
    pagination,
  } = useSelector((state) => state.luckyDraw);

  const navigate = useNavigate();

  const [page, setPage] = useState(1);
  const [limit] = useState(10);

  useEffect(() => {
    dispatch(getLuckyDraws({ page, limit }));
  }, [dispatch, page, limit]);

  const totalPages = pagination?.totalPages || 1;

  const getDrawList = () => {

    if (!luckyDraws) return [];

    if (Array.isArray(luckyDraws[0])) return luckyDraws[0];
    if (luckyDraws?.data) return luckyDraws.data;

    return luckyDraws;
  };

  const buildPages = () => {
    if (totalPages <= 6)
      return Array.from(
        { length: totalPages },
        (_, i) => i + 1
      );

    const pages = [];

    if (page > 3) {
      pages.push(1);
      if (page > 4) pages.push("...");
    }

    for (
      let i = Math.max(1, page - 1);
      i <= Math.min(totalPages, page + 1);
      i++
    ) {
      pages.push(i);
    }

    if (page < totalPages - 2) {
      if (page < totalPages - 3)
        pages.push("...");
      pages.push(totalPages);
    }

    return pages;
  };

  const scheme = luckyDraws?.data || {};
  const drawList = scheme?.draws || [];

  return (

    <>
      <div className="breadcrumb-bar mb-2 mx-1" >
        <div className="container-fluid">
          <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">

            <div className="breadcrumb-left d-flex align-items-center flex-wrap">
              <Link to="/admin/home" className="breadcrumb-link active ">
                Home
              </Link>

              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>

              <span
                className="breadcrumb-link inactive"

              >
                Lucky Draw
              </span>

            </div>

            <button
              className="add-outlet-btn"
              onClick={() => navigate("/admin/add-luckydraw")}
            >

              Add Lucky Draw
            </button>

          </div>
        </div>
      </div>


      <div className="ud-page-wrap">
        <Container fluid>

          <div className="ud-header d-flex justify-content-between align-items-center">
            <div>
              <h2 className="ud-main-title">
                Lucky Draw
              </h2>

            </div>

            {/* <Button className="ud-approve-btn" onClick={() => navigate("/admin/add-luckydraw")}>
              Add Lucky Draw
            </Button> */}
          </div>
          <Row className="g-3 mb-4">
            <Col md={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">
                    Contribution
                  </h6>
                  <h4 className="mb-0">
                    ₹{scheme.contributionAmount || 0}
                  </h4>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">
                    Max Participants
                  </h6>
                  <h4 className="mb-0">
                    {scheme.maxParticipants || 0}
                  </h4>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">
                    Maturity Amount
                  </h6>
                  <h4 className="mb-0 text-success">
                    ₹{scheme.maturityAmount?.toLocaleString()}
                  </h4>
                </Card.Body>
              </Card>
            </Col>

            <Col md={3}>
              <Card className="shadow-sm border-0 h-100">
                <Card.Body className="text-center">
                  <h6 className="text-muted mb-2">
                    Total Months
                  </h6>
                  <h4 className="mb-0">
                    {scheme.totalMonths}
                  </h4>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Card className="ud-table-card">
            <Card.Body className="p-0">
              {loading ? (
                <div className="ud-loading-state">
                  <Spinner animation="border" />
                  <span className="ud-loading-text">
                    Loading lucky draws...
                  </span>
                </div>
              ) : error ? (
                <div className="ud-error-state">
                  {error}
                </div>
              ) : (
                <div className="ud-scroll-wrap">
                  <Table
                    hover
                    borderless
                    className="ud-table align-middle mb-0"
                  >
                    <thead>
                      <tr>
                        <th>Draw No</th>
                        <th>Winner Amount</th>
                        <th>Draw Date</th>
                        <th>Status</th>
                        <th>Winner</th>
                      </tr>
                    </thead>
                    <tbody>
                      {drawList.length > 0 ? (
                        drawList.map((draw) => (
                          <tr key={draw.drawNumber}>
                            <td>
                              <strong>
                                Month {draw.drawNumber}
                              </strong>
                            </td>

                            <td>
                              <span className="fw-bold text-success">
                                ₹{draw.winnerAmount?.toLocaleString()}
                              </span>
                            </td>

                            <td>
                              {new Date(
                                draw.drawDate
                              ).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              })}
                            </td>

                            <td>
                              <Badge
                                bg={
                                  draw.status === "active"
                                    ? "primary"
                                    : draw.status === "completed"
                                      ? "success"
                                      : "warning"
                                }
                              >
                                {draw.status.toUpperCase()}
                              </Badge>
                            </td>

                            <td>
                              {draw.winnerUserId ? (
                                <Badge bg="success">
                                  Winner Declared
                                </Badge>
                              ) : (
                                <Badge bg="secondary">
                                  Pending
                                </Badge>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={5}
                            className="text-center py-4"
                          >
                            No draws found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              )}
            </Card.Body>
          </Card>

          {!loading &&
            !error &&
            drawList.length > 0 && (
              <div className="ud-pagination-wrap">
                <Pagination className="ud-pagination mb-0">
                  <Pagination.Prev
                    disabled={page === 1}
                    onClick={() =>
                      setPage((p) => p - 1)
                    }
                  />

                  {buildPages().map((p, i) =>
                    p === "..." ? (
                      <Pagination.Ellipsis
                        key={i}
                        disabled
                      />
                    ) : (
                      <Pagination.Item
                        key={p}
                        active={page === p}
                        onClick={() =>
                          setPage(p)
                        }
                      >
                        {p}
                      </Pagination.Item>
                    )
                  )}

                  <Pagination.Next
                    disabled={page === totalPages}
                    onClick={() =>
                      setPage((p) => p + 1)
                    }
                  />
                </Pagination>
              </div>
            )}
        </Container>
      </div>
    </>
  );
}